import { createShell } from '../../shell/createShell';
import { route as modifyFlightSelectorRoute } from './pages/modify_flightselector';
import { route as modifyPaxSelectorRoute } from './pages/modify_paxselector';
import { route as modifySearchRoute } from './pages/modify_search';
import { route as modifyCalendarRoute } from './pages/modify_calendar';
import { route as modifyResultsRoute } from './pages/modify_results';
import { route as modifyItineraryRoute } from './pages/modify_itinerary';
import { route as modifySummaryRoute } from './pages/modify_summary';
import { route as modifyConfirmationRoute } from './pages/modify_confirmation';
import { route as ModExitPageRoute } from './pages/exit';
import { route as modifyLCRoute } from './pages/modifylc_changetrip';
import { route as modifyStepsLCRoute } from './pages/modifylc_steps';
import { route as modifyStopoversLCRoute } from './pages/modifylc_stopovers';
import { route as modifyFlightsLCRoute } from './pages/modifylc_flightselector';
import { ModificationFunnel, ModificationLCFunnel } from '.';
const routes = [modifyFlightSelectorRoute, modifyPaxSelectorRoute, modifySearchRoute, modifyCalendarRoute, modifyResultsRoute, modifyItineraryRoute, modifySummaryRoute, modifyConfirmationRoute, ModExitPageRoute];
const routesLC = [modifyLCRoute, modifyStepsLCRoute, modifyStopoversLCRoute, modifyFlightsLCRoute, ModExitPageRoute];
export const modificationShell = createShell(ModificationFunnel, {
  options: {
    routes,
    namespace: 'modification_shell'
  }
});
export const modificationLcShell = createShell(ModificationLCFunnel, {
  options: {
    routes: routesLC,
    namespace: 'modification_lc_shell'
  }
});